export default class FavouriteViewModel {
    public id: number = 0;
    public clientId: number | null = null;
    public plantId: number | null = null;
    public name: string = '';
}